import { call, select } from 'redux-saga/effects';
import { incrementMetric } from '../../../../Services/Datadog';
import { captureWithSubmissionId } from './captureWithSubmissionId';
import recordBookingEventMutation from './recordBookingEventMutation';

/**
 * Emits one booking event to the gateway, swallowing its own errors so a failed
 * event send can never break a booking. On failure it counts a Datadog metric
 * tagged with the event name and captures to Sentry with the submission id.
 */
export default function* recordBookingEvent(event) {
  try {
    const testMode = yield select(
      (state) => state.optionalFormConfig?.testMode
    );
    yield call(recordBookingEventMutation, { ...event, testMode });
  } catch (error) {
    incrementMetric({
      name: 'clientApiBookingEventError',
      tags: { eventName: event.eventName },
    });
    captureWithSubmissionId({ error, submissionId: event.submissionId });
  }
}
